<div class="row">
    <div class="col page" *ngIf="!field.hide">
        <ng-template #fieldComponent autocomplete="nope"></ng-template>
    </div>
</div>
